<template>
    <div>
        <base-input label="Name:" v-model="group.name"></base-input>
        <base-input label="Description:" v-model="group.description"></base-input>
        <base-input label="Produce:" v-model="group.produce"></base-input>
        <base-input label="Phone:" v-model="group.phone"></base-input>
        <base-input label="Email:" v-model="group.email"></base-input>
        <base-alert type="warning">
            WARNING: Changing the biosecurity status on the orchard will also change the biosecurity status for all child sensors.
        </base-alert>
        <div class="form-group">
            <label class="form-control-label">Biosecurity:</label>
            <b-form-select v-model="group.surveillance">
              <option value="yes">Yes</option>
              <option value=null>No</option>
            </b-form-select>
        </div>
        <form-address @onSetAddress="setFarmAddress" :address="group.address"></form-address>

        <div class="form-group">
            <label class="form-control-label">Timezone:</label>
            <b-form-select v-model="group.timezone" :options="timezones"></b-form-select>
        </div>
    </div>
</template>

<script>
import BaseAlert from '../BaseAlert.vue';
import { timezones } from '@/config/Time'
export default {
  name: 'form-group',
  components: {
    BaseAlert
  },
  props: {
    group: {
      type: Object,
      default: null,
      description: ''
    }
  },
  data() {
    return {
        timezones: timezones
    };
  },
  methods: {
      setFarmAddress(address) {
          this.group.address = address
      }
  }
};
</script>
